/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

/**
 * One slice of a bit-packed field, and where it unpacks to.
 *
 * [bits] are taken from the containing field's bit stream and written into the
 * field numbered [fieldNum] after undoing this component's [scale] and [offset].
 */
public class FieldComponent(
    public val fieldNum: UByte,
    public val accumulate: Boolean,
    public val bits: Int,
    public val scale: Double,
    public val offset: Double,
) {
    internal constructor(other: FieldComponent) : this(
        other.fieldNum,
        other.accumulate,
        other.bits,
        other.scale,
        other.offset,
    )
}
